import {LocalizationStore} from 'common/i18n/store';
import {getEntityType, getEntityTypeName} from 'common/report/util/saved-entities';
import {Content} from 'common/types/app-api/content';

export function getContentTypeName(content: Content, i18n: LocalizationStore) {
  if (!content?.content_type) {
    return ``;
  }
  return i18n.print(getEntityTypeName(getEntityType(content.content_type)));
}
